<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Destination/Detail</h1>
      </div>
      <div class="flex">
        <div @click="showModalDestroy" class="mr-5 cursor-pointer">
          <fas icon="trash-alt" class="text-red-600 text-2xl" />
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Image (1020 px X 1020 px)</div>
            <div @click="showModalProductFile" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex ">
            <img
              :key="dataDestination.destination_images"
              class="w-56 h-56 mr-3 cursor-pointer"
              :src="dataDestination.destination_images"
              alt="23paskal"
              @click="showModal(dataDestination.destination_images)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Destination Info</div>
            <div
              @click="showModalEditDestinationInfo"
              class="mr-5 cursor-pointer"
            >
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="font-semibold">Name</div>
          <div v-if="dataDestination.destination_name !== ''" class="ml-5">
            {{ dataDestination.destination_name }}
          </div>
          <div class="font-semibold">Description</div>
          <!-- <div
            v-if="dataDestination.destination_description !== ''"
            class="ml-5"
          >
            {{ dataDestination.destination_description }}
          </div> -->
          <div
            class="ml-5"
            v-html="dataDestination.destination_description"
          ></div>
          <div class="font-semibold">Contact</div>
          <div v-if="dataDestination.destination_contact !== ''" class="ml-5">
            {{ dataDestination.destination_contact }}
          </div>
          <div class="font-semibold">Operation Day</div>
          <div
            v-if="dataDestination.destination_operation_day !== ''"
            class="ml-5"
          >
            {{ dataDestination.destination_operation_day }}
          </div>
          <div class="font-semibold">Time Open</div>
          <div v-if="dataDestination.destination_open_time !== ''" class="ml-5">
            {{ dataDestination.destination_open_time }}
          </div>
          <div class="font-semibold">Time Closed</div>
          <div
            v-if="dataDestination.destination_closed_time !== ''"
            class="ml-5"
          >
            {{ dataDestination.destination_closed_time }}
          </div>
          <div class="font-semibold">Status</div>
          <div v-if="dataDestination.is_active" class="ml-5">Active</div>
          <div v-else class="ml-5">Non Active</div>
        </div>
      </div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalDestroy"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Warning !</div>
          <div class="p-6 flex-grow">
            Continue To Delete This Destination
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="deleteDestination"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Update -->
    <div
      v-if="modalInfoDestination"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalEditDestinationInfo"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Edit Info</div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Status</label
                >
                <div class="flex flex-row items-center h-9 mb-5">
                  <div
                    class="relative cursor-pointer"
                    @click="update.is_active = !update.is_active"
                  >
                    <div
                      class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
                      :class="{ 'bg-app-default': update.is_active }"
                    ></div>
                    <div
                      class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
                      :class="{ 'translate-x-6': update.is_active }"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Name</label>
                <input
                  v-model="update.destination_name"
                  @keyup="destinationNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_name_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="update.destination_description"
                  @keyup="destinationDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="update.destination_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="destinationDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.destination_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.destination_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_description_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Contact</label
                >
                <input
                  v-model="update.destination_contact"
                  @keyup="destinationContactChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_contact
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="ex: 08123456789"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_contact_msg }}
                </div>
              </div>
              <div class="w-1/3 pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Operation Day</label
                >
                <input
                  v-model="update.destination_operation_day"
                  @keyup="destinationOperationDayChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_operation_day
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="ex: Mon - Fri"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_operation_day_msg }}
                </div>
              </div>
              <div class="w-1/3 pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Time Open</label
                >
                <input
                  v-model="update.destination_open_time"
                  @keyup="destinationTimeOpenChange"
                  type="time"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_open_time
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_open_time_msg }}
                </div>
              </div>
              <div class="w-1/3 pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Time Closed</label
                >
                <input
                  v-model="update.destination_closed_time"
                  @change="destinationTimeClosedChange"
                  type="time"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_closed_time
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_closed_time_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalEditDestinationInfo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updatePromoInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEditDestinationInfo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal IMAGE -->
    <div
      v-if="productModal"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 450px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Image (1020 px X 1020 px)
            </div>
            <div class="">
              <button
                @click.self="showModalProductFile"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div
              class="border-dotted border-2 p-2 rounded-lg"
              :class="[
                errors.destination_images ? 'border-red-400' : 'border-black',
              ]"
              @drop="previewFileProduct"
            >
              <input
                type="file"
                accept="image/*"
                @change="previewFileProduct"
                id="product_file"
                class="opacity-0 hidden"
              />
              <div class="flex flex-row flex-wrap">
                <div
                  v-if="avatar.previewProducts.length"
                  class="mr-1 relative rounded-lg"
                >
                  <button
                    class="absolute right-2 top-2"
                    type="button"
                    @click="removeProductFile"
                  >
                    <fas icon="trash-alt" class="text-red-600 text-3xl" />
                  </button>
                  <img
                    :src="avatar.previewProducts[0]"
                    class="w-96 h-80 rounded-lg"
                  />
                </div>
                <div
                  v-if="avatar.previewProducts.length === 0"
                  v-cloak
                  @click="chooseFileProduct()"
                  class="w-96 h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                >
                  <fas icon="image" class="text-gray-600 text-3xl" />
                </div>
              </div>
            </div>
            <div class="text-sm text-red-600 mb-5">
              {{ errors.destination_images_msg }}
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalProductFile"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="avatar.previewProducts.length === 0"
                @click="updateImageDestination"
                type="button"
                class=" text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  avatar.previewProducts.length === 0
                    ? 'bg-gray-500'
                    : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalProductFile"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal" :imageso="imageso" />
    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import CKEditor from "../../components/CKEditor.vue";
import BackButton from "../../components/BackButton.vue";
import Modal from "../../components/Modal.vue";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "ContentDetail",
  components: { Modal, Warning, BackButton, CKEditor, SuccessNotif },
  // delimiters: ['${', '}'], // Avoid Twig conflicts
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      imageso: "",
      isModalVisible: false,
      dataDestination: {},
      modalDestroy: false,
      modalInfoDestination: false,
      productModal: false,
      errors: {
        destination_images: false,
        destination_images_msg: "",
        destination_name: false,
        destination_name_msg: "",
        destination_description: false,
        destination_description_msg: "",
        destination_contact: false,
        destination_contact_msg: "",
        destination_operation_day: false,
        destination_operation_day_msg: "",
        destination_open_time: false,
        destination_open_time_msg: "",
        destination_closed_time: false,
        destination_closed_time_msg: "",
        is_active: false,
        is_active_msg: "",
      },
      update: {
        destination_name: "",
        destination_description: "",
        destination_contact: "",
        destination_operation_day: "",
        destination_open_time: "12:00",
        destination_closed_time: "17:00",
        is_active: true,
      },
      avatar: {
        previewProducts: [],
        fileProducts: [],
      },
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    destinationNameChange: function(e) {
      this.update.destination_name = e.target.value;
      this.errors.destination_name = false;
      this.errors.destination_name_msg = "";
    },
    destinationContactChange: function(e) {
      this.update.destination_contact = e.target.value;
      this.errors.destination_contact = false;
      this.errors.destination_contact_msg = "";
    },
    destinationDescriptionChange: function() {
      // this.update.event_first_description = e.target.value;
      this.errors.event_first_description = false;
      this.errors.event_first_description_msg = "";
    },
    destinationOperationDayChange: function(e) {
      this.update.destination_operation_day = e.target.value;
      this.errors.destination_operation_day = false;
      this.errors.destination_operation_day_msg = "";
    },
    destinationTimeOpenChange: function(e) {
      this.update.destination_open_time = e.target.value;
      this.errors.destination_open_time = false;
      this.errors.destination_open_time_msg = "";
    },
    destinationTimeClosedChange: function(e) {
      this.update.destination_closed_time = e.target.value;
      this.errors.destination_closed_time = false;
      this.errors.destination_closed_time_msg = "";
    },
    chooseFileProduct: function() {
      document.getElementById("product_file").click();
    },
    removeProductFile() {
      this.avatar.previewProducts = [];
      this.avatar.fileProducts = [];
    },
    previewFileProduct: function(event) {
      let input = event.target;
      let count = input.files.length;
      let index = 0;
      if (input.files) {
        while (count--) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.avatar.previewProducts.push(e.target.result);
          };
          this.avatar.fileProducts.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      }
      this.errors.destination_images = false;
      this.errors.destination_images_msg = "";
    },
    showModalDestroy: function() {
      this.modalDestroy = !this.modalDestroy;
    },
    showModalProductFile: function() {
      this.avatar = {
        previewCarousel: null,
        fileCarousel: null,
        previewProducts: [],
        fileProducts: [],
      };
      this.productModal = !this.productModal;
    },
    showModalEditDestinationInfo: function() {
      this.update.destination_name = this.dataDestination.destination_name;
      this.update.destination_description = this.dataDestination.destination_description;
      this.update.destination_contact = this.dataDestination.destination_contact;
      this.update.destination_operation_day = this.dataDestination.destination_operation_day;
      this.update.destination_open_time = this.dataDestination.destination_open_time;
      this.update.destination_closed_time = this.dataDestination.destination_closed_time;
      this.update.is_active = this.dataDestination.is_active;
      this.modalInfoDestination = !this.modalInfoDestination;
    },
    deleteDestination: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.dataDestination.id,
          }),
        });
        let respon = await res.json();
        if (respon.status === 400) {
          this._error(respon.message);
          this.modalDestroy = false;
          this.deleteButton = "Delete";
          return;
        } else if (respon.status !== 200) {
          this.modalDestroy = false;
          this._error(respon.message);
          this.deleteButton = "Delete";
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.$router.push(`/destination`);
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    updateImageDestination: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("id", this.dataDestination.id);
      this.avatar.fileProducts.map((itm) => {
        formdata.append("destination_images", itm);
      });
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/update-image`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.productModal = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.productModal = false;
        this.saveButton = "Save";
        this.detailDestination();
        this._success("Image updated.");
      } catch (err) {
        this.productModal = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updatePromoInfo: async function() {
      let data = {
        id: this.dataDestination.id,
        destination_name: this.update.destination_name,
        destination_description: this.update.destination_description,
        destination_contact: this.update.destination_contact,
        destination_operation_day: this.update.destination_operation_day,
        destination_open_time: this.update.destination_open_time,
        destination_closed_time: this.update.destination_closed_time,
        is_active: this.update.is_active,
      };
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(data),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "destination_name") {
                this.errors.destination_name = true;
                this.errors.destination_name_msg = item.message;
              }
              if (item.key === "destination_description") {
                this.errors.destination_description = true;
                this.errors.destination_description_msg = item.message;
              }
              if (item.key === "destination_contact") {
                this.errors.destination_contact = true;
                this.errors.destination_contact_msg = item.message;
              }
              if (item.key === "destination_operation_day") {
                this.errors.destination_operation_day = true;
                this.errors.destination_operation_day_msg = item.message;
              }
              if (item.key === "destination_open_time") {
                this.errors.destination_open_time = true;
                this.errors.destination_open_time_msg = item.message;
              }
              if (item.key === "destination_closed_time") {
                this.errors.destination_closed_time = true;
                this.errors.destination_closed_time_msg = item.message;
              }
              if (item.key === "is_active") {
                this.errors.is_active = true;
                this.errors.is_active_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalInfoDestination = false;
          this._error(response.message);
          this.saveButton = "Save";
          return;
        }
        this.modalInfoDestination = false;
        this.detailDestination();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalInfoDestination = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    detailDestination: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/${this.$route.params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.dataDestination = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailDestination();
  },
};
</script>
